export default __webpack_public_path__ + "static/media/tick.079a5158.png";